import { PortalRegistrationState } from "@/Common/Models/Portal/Enums/PortalRegistrationState";
import { GetPatientOverviewResponse } from "@/Common/Models/Portal/MedfarPortal";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { PatientStore } from "@/Patient/Stores/PatientStore";

class PatientProfileManagementHandler extends BaseOperationHandler {
    constructor() {
        super();
        this.RegisterOperation(LocalOperations.Portal.PortalManagment_LoadPortalProfileOverview, this.loadPortalProfileOverview);
        this.RegisterOperation(LocalOperations.Portal.Subscription_Create, this.createPortalSubscription, false);
        this.RegisterOperation(LocalOperations.Portal.Subscription_Load, this.loadSubscription, false);
        this.RegisterOperation(LocalOperations.Portal.Account_Load, this.loadAccount, false);
        this.RegisterOperation(LocalOperations.Portal.Portal_UpdateInfo, this.updatePatientProfileInformation);
        this.RegisterOperation(LocalOperations.Portal.Portal_UpdateState, this.updatePatientPortalState);
        this.RegisterOperation(LocalOperations.Portal.PaymentCustomer_Load, this.updatePaymentCustomerInfo);
    }

    private loadPortalProfileOverview(request: LocalEvent, store: PatientStore): void {
        let patientId = request.Get<string>("patientId");
        store.ActionsPortalManagement.loadPortalAccountOverview(patientId);
    }

    private createPortalSubscription(request: LocalEvent, store: PatientStore): void {
        store.ActionsPortalManagement.subscription_create(request.Get<string>("patientId"), request.Get<string>("planId"), request.Get<number>("intervalId"), request.Get<Date>("startDate"));
    }

    private loadSubscription(request: LocalEvent, store: PatientStore): void {
        let patientContactId = request.Get<string>("patientContactId");
        store.ActionsPortalManagement.subscription_get(patientContactId);
    }

    private loadAccount(request: LocalEvent, store: PatientStore): void {
        let patientContactId = request.Get<string>("patientContactId");
        store.ActionsPortalManagement.account_get(patientContactId);
    }

    private updatePatientProfileInformation(request: LocalEvent): void {
        let contactId = request.Get<string>("patientContactId");
        let portalState = request.Get<PortalRegistrationState>("portalStatus");
        let portalId = request.Get<string>("portalProfileId");
        let overview = request.Get<GetPatientOverviewResponse>("portalOverview");

        patientStore.updatePatientPortalInfo(contactId, portalId, portalState, overview);
    }

    private updatePatientPortalState(request: LocalEvent): void {
        const contactId = request.Get<string>("patientContactId");
        const portalState = request.Get<PortalRegistrationState>("portalStatus");

        patientStore.updatePatientPortalState(contactId, portalState);
    }

    private updatePaymentCustomerInfo(request: LocalEvent, store: PatientStore): void {
        let contactId = request.Get<string>("patientContactId");
        store.ActionsPortalManagement.loadCustomerPaymentInfo(contactId);
    }
}

export { PatientProfileManagementHandler };
